import environment from './env.json'

export const OKTA_ISSUER = environment.okta_issuer
export const CLIENT_ID = environment.client_id
export const IDP = environment.idp
export const SERVER_GATEWAY = environment.server_gateway
